// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1CE1g","footer":"ChangeClinic_footer__1RJ7S"};